import React from "react";
import { Chart } from "react-chartjs-2";
import { graphs } from "styleConstants";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import {
  GRAPHS_BORDER_COLORS_ARRAY,
  GRAPHS_COLORS_ARRAY,
} from "helpers/graphs";
import toast from "react-hot-toast";
import axios from "axios";
import { checkResponse } from "helpers/requests";
import { TextField } from "@mui/material";
import { useAppContext } from "contexts/AppContext/context";
import { getSubcategoryName } from "helpers/categories";
import GraphLoading from "../GraphLoading";
import { useAuthContext } from "contexts/AuthContext/context";

export default function RentedSubcategoriesGraph() {
  const { authState } = useAuthContext();
  const { partner } = authState;
  // Get date
  const curDate = new Date();
  const curMonth = curDate.getMonth();
  const curYear = curDate.getFullYear();
  const firstDayDate = new Date(curYear, curMonth, 1);

  const { appState } = useAppContext();
  const { subcategories: contextSubcategories } = appState;
  const [monthOnView, setMonthOnView] = React.useState(
    firstDayDate.toISOString().split("T")[0]
  );
  const [labels, setLabels] = React.useState<Array<string>>([]);
  const [values, setValues] = React.useState<Array<number>>([]);
  const [loading, setLoading] = React.useState(false);

  async function getData() {
    try {
      setLoading(true);

      // Make request
      const server = process.env.REACT_APP_SERVER_URL;
      const params = { date: monthOnView, securityID: partner?.id };
      const url = `${server}/graphs/products/rented-subcategories`;
      const res = await axios.get(url, { params });

      // Check response
      if (!checkResponse(res)) throw res;

      // Splite timestamp and categories
      const { ts, ...subcategories } = res.data.data;

      // Create labels and values
      const subcategoriesIds = Object.keys(subcategories);
      const resLabels: string[] = [];
      const resValues: number[] = [];
      subcategoriesIds.forEach((subcategoryId) => {
        const subcategoryName = getSubcategoryName(
          subcategoryId,
          contextSubcategories
        );
        resLabels.push(subcategoryName || "Sin nombre");
        resValues.push(subcategories[subcategoryId]);
      });
      setLabels(resLabels);
      setValues(resValues);

      setLoading(false);
    } catch (error) {
      console.log("GET RENTED SUBCATEGORIES", error);
      toast.error(
        "Hubo un error obteniendo los datos: Subcategorías Alquiladas"
      );
    }
  }

  React.useEffect(() => {
    getData();
  }, [monthOnView]);

  return (
    <div className={graphs.graphContainer}>
      <div className={graphs.graphsTopContainer}>
        <h1 className={graphs.graphTitle}>Total de Subcategorías Alquiladas</h1>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            views={["month", "year"]}
            value={monthOnView}
            onChange={(newValue: any) => {
              const formatedDate = new Date(newValue)
                .toISOString()
                .split("T")[0];
              setMonthOnView(formatedDate);
            }}
            renderInput={(params: any) => (
              <TextField
                {...params}
                helperText={null}
                size="small"
                sx={{ width: "300px" }}
              />
            )}
          />
        </LocalizationProvider>
      </div>
      {!loading ? (
        <div className="w-[400px]">
          <Chart
            options={{
              plugins: {
                legend: {
                  position: "bottom",
                },
              },
            }}
            type="doughnut"
            data={{
              labels,
              datasets: [
                {
                  data: values,
                  borderWidth: 2,
                  borderColor: GRAPHS_BORDER_COLORS_ARRAY,
                  backgroundColor: GRAPHS_COLORS_ARRAY,
                },
              ],
            }}
          />
        </div>
      ) : (
        <GraphLoading />
      )}
    </div>
  );
}
